import { Directive, HostListener, Input, OnInit } from '@angular/core';
import { MarketStore } from '../market.store';
import { Subscription } from '@shared/models';

@Directive({
  selector: '[cwtManageSubscription]'
})
export class ManageSubscriptionDirective implements OnInit {

  @Input('cwtManageSubscription') subscription: Subscription;

  constructor(private store: MarketStore) { }

  ngOnInit(): void {
    this.store.init().subscribe();
  }


  @HostListener('click')
  public manageSubscription() {
    if (!this.subscription) return;
    this.store.manage(this.subscription);
  }

}
